var map = {
	"./layouts/bbb/default.js": 1226,
	"./layouts/iframe/default.js": 965,
	"./layouts/jsqueue/empty.js": 966,
	"./layouts/jsqueue/page-white-header.js": 967,
	"./layouts/jsqueue/page.js": 979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 938;